import { render } from "./PantryPRFoodView.vue?vue&type=template&id=f9898f1c&ts=true"
import script from "./PantryPRFoodView.vue?vue&type=script&lang=ts"
export * from "./PantryPRFoodView.vue?vue&type=script&lang=ts"

import "./PantryPRFoodView.vue?vue&type=style&index=0&id=f9898f1c&lang=scss"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__